<td>
  <div class="d-flex">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'mydepot.depotoverview.canceled-orders.labels.assetName' | transloco }}
    </div>
    <div class="text-md-left text-right d-inline-flex">
      <web-components-instrument-details-link class="font-medium text-color-primary" [isin]="order.isin">
        {{ order.assetName }}
      </web-components-instrument-details-link>
    </div>
  </div>
  <div class="d-flex text-color-primary">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'mydepot.depotoverview.canceled-orders.labels.isin' | transloco }}
    </div>
    <div class="font-light d-inline-flex">
      {{ order | shorthandSymbol }}
      @if (actionsEnabled) {
        <web-components-watchlist-toggle [isin]="order.isin" />
      }
    </div>
  </div>
</td>
<td>
  <div class="d-flex justify-content-end">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'mydepot.depotoverview.canceled-orders.labels.quantity' | transloco }}
    </div>
    <div>
      {{ order.quantity - order.executedQuantity | number: '1.0-8' }}
      @if (order | orderIsPartiallyFilled) {
        <span class="text-color-primary"> (von {{ order.quantity }})</span>
      }
    </div>
  </div>
  <div class="d-flex text-color-primary justify-content-end">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'mydepot.depotoverview.canceled-orders.labels.status' | transloco }}
    </div>
    <div class="text-color-primary text-right font-medium">
      {{ order.status | displayLabel }}
    </div>
  </div>
</td>
<td>
  <div class="d-flex justify-content-end">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'mydepot.depotoverview.canceled-orders.labels.execType' | transloco }}
    </div>
    <div class="text-color-primary">
      <order-item-exec-type [order]="order" />
    </div>
  </div>
  <div class="d-flex text-color-primary justify-content-end">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'mydepot.depotoverview.canceled-orders.labels.stopLimit' | transloco }}
    </div>
    <order-zero-stop-limit-data [order]="order" />
  </div>
</td>
<td>
  <div class="d-flex justify-content-end">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'mydepot.depotoverview.canceled-orders.labels.cancelDate' | transloco }}
    </div>
    <div class="text-color-primary">
      {{ order.cancelDate | date: 'shortDate' }}
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'mydepot.depotoverview.canceled-orders.labels.validToDate' | transloco }}
    </div>
    <div class="text-color-primary">
      {{ order.validToDate | date: 'shortDate' }}
    </div>
  </div>
</td>
<td>
  <div class="d-flex text-color-primary justify-content-end">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'mydepot.depotoverview.canceled-orders.labels.direction' | transloco }}
    </div>
    <div>{{ order.direction | displayLabel }}</div>
  </div>
  <div class="d-flex text-color-primary justify-content-end">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'mydepot.depotoverview.canceled-orders.labels.value' | transloco }}
    </div>
    <order-value [order]="order" type="canceled" />
  </div>
</td>
@if (actionsEnabled) {
  <td class="margin-xs-bottom-15 margin-sm-bottom-15">
    <div class="d-flex justify-content-end align-items-center">
      @if (!(order | orderExecType: 'savings') && !(order | orderExecType: 'fraction')) {
        <div
          class="btn-icon cursor-pointer"
          title="Duplizieren"
          [routerLink]="commonRoutes.postlogin.buyAndSell"
          [queryParams]="orderQueryParams"
        >
          <svg class="icon icon-24" viewBox="0 0 24 22" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
              <path id="fyzc4vz1ya" d="M0 0h14.844v17.44H0z" />
              <path id="uszhg4njic" d="M0 0h14.773v17.44H0z" />
            </defs>
            <g fill="none" fill-rule="evenodd">
              <g transform="translate(1 1)">
                <mask id="n7m10afqjb" fill="#fff">
                  <use xlink:href="#fyzc4vz1ya" />
                </mask>
                <path
                  d="M5.618 4.576a7.58 7.58 0 0 1 7.72-1.885 1.154 1.154 0 0 0 1.451-.753 1.163 1.163 0 0 0-.749-1.46C8.813-1.204 3.22 1.694 1.545 6.953A10.052 10.052 0 0 0 1.8 13.75a.231.231 0 0 1-.087.28l-1.294.857a.933.933 0 0 0 .321 1.688l4.074.845a.926.926 0 0 0 1.09-.724l.845-4.098A.93.93 0 0 0 6.03 11.5a.92.92 0 0 0-.694.134l-1.238.82a.23.23 0 0 1-.348-.124 7.72 7.72 0 0 1 1.869-7.754"
                  fill="#248eff"
                  mask="url(#n7m10afqjb)"
                />
              </g>
              <g transform="translate(8.227 3.56)">
                <mask id="0chfy2b49d" fill="#fff">
                  <use xlink:href="#uszhg4njic" />
                </mask>
                <path
                  d="M14.759 1.704a.928.928 0 0 0-.705-.75L9.997.024A.924.924 0 0 0 8.89.72l-.001.003-.925 4.08a.93.93 0 0 0 .696 1.113c.239.055.49.012.697-.12l1.334-.842c.06-.04.134-.049.202-.025.067.025.12.08.141.148 1.3 4.03-.896 8.356-4.903 9.663a7.587 7.587 0 0 1-4.605.03 1.153 1.153 0 0 0-1.464.73 1.164 1.164 0 0 0 .783 1.49c5.244 1.632 10.809-1.321 12.43-6.596.674-2.19.579-4.546-.27-6.674-.04-.103 0-.22.093-.279l1.244-.786a.932.932 0 0 0 .418-.95"
                  fill="#248eff"
                  mask="url(#0chfy2b49d)"
                />
              </g>
            </g>
          </svg>
        </div>
      }
    </div>
  </td>
}
